const schema = () => ({
  title: 'Intro',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['eyebrow', 'heading', 'body', 'signature'],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Surtitre',
      type: 'string',
      default: 'Notre maison',
    },
    heading: {
      title: 'Titre',
      type: 'string',
      default: 'Une table de quartier, pensée comme un dimanche en famille.',
    },
    body: {
      title: 'Texte',
      type: 'string',
      widget: 'textarea',
    },
    signature: {
      title: 'Signature',
      type: 'string',
      default: "— L'équipe d'À Ciel Ouvert",
    },
  },
  required: [],
});

export default schema;
